import { Reveal } from "./Reveal";
import { MODEL, ABOUT_IMAGE } from "../data";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="px-6 lg:px-12 py-24 lg:py-40">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Left: section label + heading */}
        <div className="lg:col-span-6">
          <Reveal>
            <h2 className="mt-6 font-serif text-4xl lg:text-6xl font-light leading-[0.95] tracking-tight text-foreground">
              The face behind
              <br />
              <span className="italic">the frame.</span>
            </h2>
          </Reveal>
        </div>

        {/* Right: portrait */}
        <div className="lg:col-span-5 lg:col-start-8">
          <Reveal delay={0.1}>
            <div className="border border-border p-3 bg-card">
              <img
                src={ABOUT_IMAGE}
                alt="Portrait of Fateh Bhinder"
                loading="lazy"
                className="w-full aspect-[3/4] object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>

      {/* Measurements */}
      <Reveal>
        <div className="mt-16 lg:mt-24 border-t border-border pt-10">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-accent">
            Measurements
          </p>
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-y-8 gap-x-6">
            {MODEL.stats.map((s) => (
              <div key={s.label} data-testid={`stat-${s.label.toLowerCase()}`}>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
                  {s.label}
                </p>
                <p className="mt-2 font-serif text-2xl font-light text-foreground">{s.value}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
